export default "__VITE_PUBLIC_ASSET__0dfe1588__"